<!-- Las claves de los proveedores. Sin `comercio`: las de plataforma. Con `comercio`: la
     clave propia de ese comercio, que manda sobre la de plataforma. Nada se abre en un
     modal: cambiar y quitar se resuelven en la fila. -->
<div class="space-y-4">

  <div class="kb-aviso kb-aviso-alerta" *ngIf="sinClaveMaestra" role="status">
    <i class="fas fa-lock mt-0.5" aria-hidden="true"></i>
    <p class="m-0">
      El servidor no tiene la clave maestra de IA configurada, así que desde aquí no se pueden
      guardar claves. Las que vienen de las variables del servidor siguen funcionando.
    </p>
  </div>

  <!-- Cargando -->
  <div *ngIf="cargando" class="space-y-2" aria-live="polite" aria-busy="true">
    <div class="kb-skeleton h-10 w-full" *ngFor="let s of [1,2,3]"></div>
  </div>

  <!-- No se pudo leer -->
  <div class="flex flex-wrap items-center justify-between gap-3 rounded-lg border border-border px-4 py-3"
       *ngIf="!cargando && error" role="alert">
    <p class="m-0 text-sm text-muted-foreground">
      <i class="fas fa-exclamation-circle mr-1.5 text-destructive" aria-hidden="true"></i>
      No se pudieron leer las claves. {{ error }}
    </p>
    <button type="button" class="kb-btn kb-btn-outline kb-btn-sm" (click)="cargar()">
      <i class="fas fa-redo !text-foreground" aria-hidden="true"></i>Reintentar
    </button>
  </div>

  <div class="kb-tabla-plana" *ngIf="!cargando && !error">
    <table class="kb-table">
      <thead class="kb-thead">
        <tr>
          <th class="kb-th">Proveedor</th>
          <th class="kb-th">{{ comercio ? 'Clave propia' : 'Clave en uso' }}</th>
          <th class="kb-th">{{ comercio ? 'Si no tiene propia' : 'Cargada en esta consola' }}</th>
          <th class="kb-th kb-th-acciones" *ngIf="puedeEditar">Acciones</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let p of PROVEEDORES">
          <tr class="kb-tr">
            <td class="kb-td">
              <span class="kb-td-titulo">{{ p.nombre }}</span>
            </td>

            <!-- ── Plataforma: la que usa el motor hoy, y de dónde sale ── -->
            <td class="kb-td" *ngIf="!comercio">
              <ng-container *ngIf="enUso(p.id)?.configurado; else sinClave">
                <span class="font-mono text-sm">••••{{ enUso(p.id)?.ultimos4 || '····' }}</span>
                <p class="kb-td-sub">{{ ORIGEN[enUso(p.id)?.origen || ''] || 'Origen desconocido' }}</p>
                <span class="kb-badge kb-badge-exito mt-1" *ngIf="enUso(p.id)?.operativo">
                  <i class="fas fa-check-circle" aria-hidden="true"></i>Contesta</span>
                <span class="kb-badge kb-badge-alerta mt-1" *ngIf="!enUso(p.id)?.operativo">
                  <i class="fas fa-exclamation-triangle" aria-hidden="true"></i>No contesta</span>
                <!-- El error del proveedor, traducido; el crudo (en inglés) sólo en el `title`. -->
                <p class="kb-td-sub" *ngIf="!enUso(p.id)?.operativo && enUso(p.id)?.ultimoError"
                   [title]="enUso(p.id)?.ultimoError || ''">
                  {{ errorDeProveedor(enUso(p.id)?.ultimoError) }}</p>
              </ng-container>
              <ng-template #sinClave>
                <span class="text-sm text-muted-foreground">{{ estado ? 'Sin clave' : '—' }}</span>
              </ng-template>
            </td>
            <td class="kb-td" *ngIf="!comercio">
              <ng-container *ngIf="guardada(p.id) as g; else nadaGuardado">
                <span class="font-mono text-sm">••••{{ g.ultimos4 }}</span>
                <p class="kb-td-sub" *ngIf="g.cargadaPor || g.cargadaEl">
                  {{ g.cargadaPor || '' }}<ng-container *ngIf="g.cargadaPor && g.cargadaEl"> · </ng-container>{{ g.cargadaEl ? fechaHora(g.cargadaEl) : '' }}
                </p>
              </ng-container>
              <ng-template #nadaGuardado><span class="text-sm text-muted-foreground">Ninguna</span></ng-template>
            </td>

            <!-- ── Comercio: su clave propia, y qué usa si no la tiene ── -->
            <td class="kb-td" *ngIf="comercio">
              <ng-container *ngIf="guardada(p.id) as g; else sinPropia">
                <span class="font-mono text-sm">••••{{ g.ultimos4 }}</span>
                <p class="kb-td-sub" *ngIf="g.cargadaPor || g.cargadaEl">
                  {{ g.cargadaPor || '' }}<ng-container *ngIf="g.cargadaPor && g.cargadaEl"> · </ng-container>{{ g.cargadaEl ? fechaHora(g.cargadaEl) : '' }}
                </p>
              </ng-container>
              <ng-template #sinPropia><span class="text-sm text-muted-foreground">No tiene</span></ng-template>
            </td>
            <td class="kb-td" *ngIf="comercio">
              <span class="text-sm" *ngIf="guardada(p.id)">No aplica: usa la suya</span>
              <ng-container *ngIf="!guardada(p.id)">
                <span class="text-sm" *ngIf="enUso(p.id)?.configurado">
                  La de plataforma, <span class="font-mono">••••{{ enUso(p.id)?.ultimos4 || '····' }}</span>
                </span>
                <span class="text-sm text-muted-foreground" *ngIf="!enUso(p.id)?.configurado">
                  {{ estado ? 'Tampoco hay de plataforma' : '—' }}
                </span>
              </ng-container>
            </td>

            <td class="kb-td-acciones whitespace-nowrap" *ngIf="puedeEditar">
              <div class="kb-acciones-grupo">
                <button type="button" class="kb-btn kb-btn-outline kb-btn-sm"
                        *ngIf="puedeEditar && !sinClaveMaestra" [disabled]="!!ocupado[p.id]"
                        (click)="abrir(p.id)">
                  <i class="fas fa-key !text-foreground" aria-hidden="true"></i>{{ guardada(p.id) ? 'Cambiar la clave' : 'Cargar una clave' }}
                </button>
                <button type="button" class="kb-btn kb-btn-ghost kb-btn-sm"
                        [disabled]="!!ocupado[p.id]" (click)="probar(p.id)"
                        *ngIf="puedeEditar && (guardada(p.id) || enUso(p.id)?.configurado)"
                        title="Hace UNA llamada mínima al proveedor con esta clave">
                  <i class="fas" [ngClass]="ocupado[p.id] === 'probar' ? 'fa-circle-notch fa-spin' : 'fa-vial'" aria-hidden="true"></i>Probar
                </button>
                <button type="button" class="kb-btn kb-btn-ghost kb-btn-sm !text-destructive"
                        *ngIf="puedeEditar && guardada(p.id)" [disabled]="!!ocupado[p.id]"
                        (click)="pedirQuitar(p.id)">
                  <i class="fas fa-trash-alt" aria-hidden="true"></i>Quitar
                </button>
              </div>
            </td>
          </tr>

          <!-- Cargar o cambiar la clave: en la fila, con campo de contraseña. -->
          <tr class="kb-tr" *ngIf="editando === p.id">
            <td class="kb-td kb-fondo-suave" [attr.colspan]="puedeEditar ? 4 : 3">
              <form class="flex flex-col gap-3 sm:flex-row sm:items-end" (ngSubmit)="guardar(p.id)" autocomplete="off">
                <div class="min-w-0 flex-1 space-y-1.5">
                  <label class="kb-label" [attr.for]="'ia-clave-' + p.id + (comercio || '')">
                    Clave de {{ p.nombre }}{{ comercio ? ' para ' + comercio : '' }}
                  </label>
                  <input class="kb-input w-full font-mono" type="password" autocomplete="new-password"
                         spellcheck="false" [id]="'ia-clave-' + p.id + (comercio || '')"
                         [name]="'clave-' + p.id" [(ngModel)]="clave"
                         placeholder="Pega la clave aquí">
                  <p class="kb-hint">Se guarda cifrada en el servidor. Después sólo se ven los cuatro últimos.</p>
                </div>
                <div class="flex shrink-0 gap-2">
                  <button type="submit" class="kb-btn kb-btn-primary" [disabled]="!clave.trim() || !!ocupado[p.id]">
                    <i class="fas" [ngClass]="ocupado[p.id] === 'guardar' ? 'fa-circle-notch fa-spin' : 'fa-save'" aria-hidden="true"></i>Guardar la clave
                  </button>
                  <button type="button" class="kb-btn kb-btn-ghost" (click)="cancelar()">Cancelar</button>
                </div>
              </form>
            </td>
          </tr>

          <!-- Quitar: el segundo clic, en la misma fila. -->
          <tr class="kb-tr" *ngIf="confirmandoQuitar === p.id">
            <td class="kb-td kb-fondo-suave" [attr.colspan]="puedeEditar ? 4 : 3">
              <div class="flex flex-wrap items-center justify-between gap-3">
                <p class="m-0 text-sm">
                  ¿Quitar la clave <span class="font-mono">••••{{ guardada(p.id)?.ultimos4 }}</span> de {{ p.nombre }}?
                  <span class="text-muted-foreground">{{ comercio
                    ? 'El comercio pasa a usar la de plataforma.'
                    : 'El motor pasa a usar la variable del servidor, si la hay.' }}</span>
                </p>
                <div class="flex gap-2">
                  <button type="button" class="kb-btn kb-btn-danger kb-btn-sm" [disabled]="!!ocupado[p.id]" (click)="quitar(p.id)">
                    <i class="fas" [ngClass]="ocupado[p.id] === 'quitar' ? 'fa-circle-notch fa-spin' : 'fa-trash-alt'" aria-hidden="true"></i>Sí, quitarla
                  </button>
                  <button type="button" class="kb-btn kb-btn-ghost kb-btn-sm" (click)="confirmandoQuitar = null">No</button>
                </div>
              </div>
            </td>
          </tr>

          <!-- El resultado de la última acción, pegado a su fila. -->
          <tr class="kb-tr" *ngIf="aviso[p.id]">
            <td class="kb-td py-2" [attr.colspan]="puedeEditar ? 4 : 3">
              <p class="m-0 text-sm" role="status" [title]="aviso[p.id]?.crudo || ''"
                 [ngClass]="aviso[p.id]?.ok ? 'kb-texto-exito' : 'kb-texto-peligro'">
                <i class="fas mr-1.5" [ngClass]="aviso[p.id]?.ok ? 'fa-check-circle' : 'fa-exclamation-circle'" aria-hidden="true"></i>{{ aviso[p.id]?.texto }}
              </p>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>

  <p class="kb-hint" *ngIf="!cargando && !error">
    <ng-container *ngIf="!comercio">
      Se usa, en este orden: la clave propia del comercio, la cargada en esta consola y la variable del servidor.
    </ng-container>
    <ng-container *ngIf="comercio">
      La clave propia sólo la usa este comercio y manda sobre la de plataforma. El comercio nunca la ve.
    </ng-container>
  </p>
</div>
